export default "__VITE_PUBLIC_ASSET__76e878b1__"